import React from "react";
import PropTypes from "prop-types";
import debounce from "lodash/debounce";
import classNames from "classnames";

import Icon from "components/library/Icon";
import TextInput from "components/library/TextInput";
import styles from "./Search.css";

export default class Search extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this._handleChange.bind(this);

    // props.onChange is required by PropTypes but since we re-bind it in the
    // constructor, it will break the entire app if you don't pass the value in
    // before the render cycle even happens. We are opting to prevent the exception
    // but keep the proptypes warning.
    this.debouncedOnChange = debounce(props.onChange || (() => {}), 250);
  }

  _handleChange(event) {
    this.debouncedOnChange(event.target.value);
  }

  render() {
    return (
      <div className={styles.root}>
        <div className={styles.search}>
          <Icon name="search" className={styles.searchIcon} />
          <div className={styles.input}>
            <TextInput
              placeholder={this.props.placeholder}
              className={classNames(styles.searchField, this.props.className)}
              type="search"
              onChange={this.handleChange}
            />
          </div>
        </div>
      </div>
    );
  }
}

Search.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  debounce: PropTypes.bool,
};
